import { IconPinFilled } from '@u21/tabler-icons';
import { U21Chip } from 'app/shared/u21-ui/components';

import { SavedFilter } from 'app/modules/filters/models';

interface Props {
  onClick: () => void;
  pinned: boolean;
  savedFilter: SavedFilter;
}

export const AppliedSavedFilterChip = ({
  onClick,
  pinned,
  savedFilter,
}: Props) => {
  return (
    <U21Chip
      color="primary"
      icon={pinned ? <IconPinFilled /> : undefined}
      onClick={onClick}
      rounded
      variant="filled"
    >
      {savedFilter.title}
    </U21Chip>
  );
};
